import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App'
import { typografReady } from '@/lib/typograf'
import '@fontsource-variable/inter/wght.css'
// Display headings: Literata stands in for the Fraunces of docs/design.md,
// which has no Cyrillic
import '@fontsource-variable/literata/wght.css'
import '@fontsource-variable/literata/wght-italic.css'
import '@/index.css'

// Waiting at most the loader's timeout: the first render already has
// non-breaking spaces, and nothing reflows a moment later
typografReady.then(() => {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
})
